import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpService } from '../http.service';
import { HelperService } from '../helper.service';
import { HttpClient } from '@angular/common/http';
import * as XLSX from 'xlsx';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.csv';
import * as FileSaver from 'file-saver'
import { Subject } from 'rxjs';
import { cloneDeep } from 'lodash';
import { HttpFileService } from '../http-file.service';
@Injectable({
  providedIn: 'root',
})
export class PreAssessmentService {
  constructor(
    private httpService: HttpService,
    public helperService: HelperService,
    public httpClient: HttpClient,
    public httpFileService: HttpFileService,
    private router: Router
  ) { }

  preAssessmentList(payload: any) {
    return this.httpService.post(`admin/get/medscheck/user_list`, payload);
  }
  preAssessmentOverview(id: any) {
    return this.httpService.post(`admin/get/medscheck/user_details`, { id: id });
  }
  getLastUpdateOn(payload: any) {
    return this.httpService.post(`admin/medscheck/get_last_update_on`, payload);
  }

  userPlanListingForPopup(payload: any) {
    return this.httpService.post(`admin/medscheck/healthcareplan/all_plan_list`, payload);
  }

  getFollowupHealthcarePlan(payload: any) {
    return this.httpService.post(`admin/medscheck/get_followup_healthcare_plan`, payload);
  }
  AddPlansToUser(payload: any) {
    return this.httpService.post(`admin/medscheck/user/healthcareplan/add`, payload);
  }
  saveFollowupHealthcarePlan(payload: any) {
    return this.httpService.postForConsentHtml(`admin/medscheck/save_followup_healthcare_plan`, payload);
  }
  userSelectedPlanList(payload: any) {
    return this.httpService.post(`admin/medscheck/user/healthcareplan/list`, payload);
  }
  editPlan(payload: any) {
    return this.httpService.post(`admin/medscheck/user/healthcareplan/edit`, payload);
  }
  removeUserPlan(payload: any) {
    return this.httpService.post(`admin/medscheck/user/healthcareplan/delete`, payload);
  }
  getStatusList(payload: any = []) {
    return this.httpService.post(`admin/get/medscheck/status_list`, payload);
  }

  getStatesList(payload: any = []) {
    return this.httpService.post(`admin/medscheck/province_list`, payload);
  }

  getAdminList(payload: any = []) {
    return this.httpService.post(`admin/user/tasks/get_admin_list`, payload);
  }

  changeStatus(payload: any) {
    return this.httpService.post(`admin/medscheck/update_status`, payload);
  }
  get_cancel_reason(payload: any) {
    return this.httpService.post(`admin/get/medscheck/cancel_reason_list`, payload);
  }
  save_rejected_reason(payload: any) {
    return this.httpService.post(`admin/medscheck/cancel_reason/create`, payload);
  }
  download_acknowledgement(payload: any) {
    return this.httpService.post(`admin/medscheck/user/download_acknowledgement`, payload);
  }
  calendly_calls(payload: any) {
    return this.httpService.post(`admin/medscheck/user/calendly_calls`, payload);
  }
  userSummaryListingForPopup(payload: any) {
    return this.httpService.post(`admin/medscheck/takehomesummary/all_plan_list`, payload);
  }
  AddSummaryToUser(payload: any) {
    return this.httpService.post(`admin/medscheck/user/takehomesummary/add`, payload);
  }
  userSelectedSummaryList(payload: any) {
    return this.httpService.post(`admin/medscheck/user/takehomesummary/list`, payload);
  }
  removeUserSummary(payload: any) {
    return this.httpService.post(`admin/medscheck/user/takehomesummary/delete`, payload);
  }
  editSummary(payload: any) {
    return this.httpService.post(`admin/medscheck/user/takehomesummary/edit`, payload);
  }
  couriersListForPrscriptionStatus(payload: any) {
    return this.httpService.post(`admin/couriers/list`, payload);
  }
  reasonListForPrscriptionStatus(payload: any) {
    return this.httpService.post(`admin/prescription/reason/list-all`, payload);
  }
  getCustomeMessage(payload: any) {
    return this.httpService.post(`admin/get/message-template/by-status`, payload);
  }
  getPatientFacingContent(payload: any) {
    return this.httpService.post(`admin/reason/get_patient_facing_content`, payload);
  }
  prescriptionReasonAdd(payload: any) {
    return this.httpService.post(`admin/prescription/reason/add`, payload);
  }
  prescriptionCourierAdd(payload: any) {
    return this.httpService.post(`admin/couriers/create`, payload);
  }
  changePrescriptionStatus(payload: any) {
    return this.httpService.post(`admin/prescription/status-update`, payload);
  }
  getPharmacistFeedbackData(payload: any) {
    return this.httpService.post(`admin/medscheck/get_pharmacist_feedback`, payload);
  }
  savePharmacistFeedback(payload: any) {
    return this.httpService.postForConsentHtml(`admin/medscheck/save_pharmacist_feedback`, payload);
  }
  changePrescriptionTrsStatus(payload: any) {
    return this.httpService.post(`admin/transfer-prescription/status-update`, payload);
  }
  getFollowUp(payload: any) {
    return this.httpService.post(`admin/medscheck/get_followup`, payload);
  }

  getDcpFollowup(payload: any) {
    return this.httpService.post(`admin/medscheck/get_dcp_followup_list`, payload);
  }

  getCalendyLinks(payload: any) {
    return this.httpService.post(`admin/medscheck/get_calendly_links`, payload);
  }
  bookNextAnnualConsultation(payload: any) {
    return this.httpService.post(`admin/medscheck/book_next_annual_consultation`, payload);
  }

  getFollowUpUserlist(payload: any) {
    return this.httpService.post(`admin/medscheck/get_userlist`, payload);
  }

  checkUserConsultation(payload: any) {
    return this.httpService.post(`admin/medscheck/check_user_consultation`, payload);
  }

  bookFollowUp(payload: any) {
    return this.httpService.post(`admin/medscheck/verify_consultation`, payload);
  }
  createInitialConsultation(payload: any) {
    return this.httpService.post(`admin/medscheck/create_initial_consultation`, payload);
  }

  updateDiseaseStatus(payload: any) {
    return this.httpService.post(`admin/medscheck/save_disease`, payload);
  }

  getPatientInfo(payload: any) {
    return this.httpService.post(`admin/medscheck/get_patient_info`, payload);
  }
  updateFollowAdhocTopic(payload: any) {
    return this.httpService.post(`admin/medscheck/adhoc/update_follow_adhoc_topic`, payload);
  }
  tpUpdateRequestDate(payload: any) {
    return this.httpService.post(`admin/user/tp-update-request-date`, payload);
  }

  getProvinceList() {
    return this.httpService.post(`admin/medscheck/province_list`, null);
  }

  updatePreAssesmentQuestion(payload: any) {
    return this.httpService.post(`admin/medscheck/update_pre_assesment_question`, payload);
  }

  autoCalculateBmi(payload: any) {
    return this.httpService.post(`admin/medscheck/calculate_bmi`, payload);
  }

  getChecklist_of_completeness(payload: any) {
    return this.httpService.post(`admin/medscheck/get_checklist_of_completeness`, payload);
  }

  postChecklist_of_completeness(payload: any) {
    return this.httpService.post(`admin/medscheck/checklist_of_completeness`, payload);
  }

  get_medications_review(payload: any) {
    return this.httpService.post(`admin/medscheck/get_medications`, payload);
  }

  non_priscription_product(payload: any) {
    return this.httpService.post(`admin/medscheck/non_priscription_product`, payload);
  }

  add_medications(payload: any) {
    return this.httpService.post(`admin/medscheck/add_medications`, payload);
  }

  get_modify_medications(payload: any) {
    return this.httpService.post(`admin/medscheck/edit_medication`, payload);
  }

  add_therapeutic_issue(payload: any) {
    return this.httpService.post(`admin/medscheck/add_therapeutic_issue`, payload);
  }

  get_therapeutic_issue(payload: any) {
    return this.httpService.post(`admin/medscheck/edit_therapeutic_issue`, payload);
  }

  delete_therapeutic_issue(payload: any) {
    return this.httpService.post(`admin/medscheck/delete_therapeutic_issue`, payload);
  }

  update_medication_further_info(payload: any) {
    return this.httpService.post(`admin/medscheck/update_medication_further_info`, payload);
  }

  discontinue_medication(payload: any) {
    return this.httpService.post(`admin/medscheck/discontinue_medication`, payload);
  }

  therapeutic_review_notes(payload: any) {
    return this.httpService.post(`admin/medscheck/therapeutic_review_notes`, payload);
  }

  get_goals(payload: any) {
    return this.httpService.post(`admin/medscheck/get_goals`, payload);
  }

  save_patient_rediness(payload: any) {
    return this.httpService.post(`admin/medscheck/save_patient_rediness`, payload);
  }

  save_patient_self_goals(payload: any) {
    return this.httpService.post(`admin/medscheck/save_patient_self_goals`, payload);
  }

  publish_followUp_care_plan(payload: any) {
    return this.httpService.post(`admin/medscheck/publish_followup_care_plan`, payload);
  }

  deletePatientSelfGoals(payload: any) {
    return this.httpService.post(`admin/medscheck/delete_patient_self_goals`, payload);
  }

  get_user_care_plan(payload: any) {
    return this.httpService.post(`admin/medscheck/get_user_care_plan`, payload);
  }

  get_all_care_plan_list(payload: any) {
    return this.httpService.post(`admin/medscheck/get_all_care_plan_list`, payload);
  }

  add_health_care_plan(payload: any) {
    return this.httpService.postForConsentHtml(`admin/medscheck/add_health_care_plan`, payload);
  }

  addFinalTakeHomeSummary(payload: any) {
    return this.httpService.postForConsentHtml(`admin/medscheck/add_final_take_home_summary`, payload);
  }

  getFinalTakeHomeSummary(payload: any) {
    return this.httpService.post(`admin/medscheck/dcp_take_home_summary`, payload);
  }

  getConsultationTopicPopup(payload: any) {
    return this.httpService.post(`admin/medscheck/get_consultation_topic_popup`, payload);
  }

  updateInternalnotes(payload: any) {
    return this.httpService.postForConsentHtml(`admin/medscheck/update_internal_notes`, payload);
  }

  getUpdateInternalnotesData(payload: any) {
    return this.httpService.post(`admin/medscheck/get_internal_notes`, payload);
  }

  getDcpHeaderData(id: any) {
    return this.httpService.post(`admin/get/medscheck/user_details`, { id: id });
  }

  getCareplan(payload: any) {
    return this.httpService.post(`admin/medscheck/delete_health_care_plan`, payload);
  }

  getReviewPdf(payload: any) {
    return this.httpService.post(`admin/medscheck/get_review_pdf`, payload);
  }

  getBillingInfo(payload: any) {
    return this.httpService.post(`admin/medscheck/get_billing_info`, payload);
  }
  saveBillingInfo(payload: any) {
    return this.httpService.post(`admin/medscheck/save_billing_info`, payload);
  }

  getPastConsultations(payload: any) {
    return this.httpService.post(`admin/medscheck/previous_consultation_detail`, payload);
  }

  GetLedActionItem(payload: any) {
    return this.httpService.post(`admin/medscheck/led/action_item`, payload);
  }
  saveActionItems(payload: any) {
    return this.httpService.post(`admin/medscheck/save_action_items`, payload);
  }

  get_biometrics_update(payload: any) {
    return this.httpService.post(`admin/medscheck/biometrics_update`, payload);
  }

  save_biometrics_update(_payload: any) {
    const payload = cloneDeep(_payload);
    payload.biometerics_data.forEach((data: any) => {
      if (data?.question_data) {
        if (data?.question_data?.radio_val) {
          data.question_data.radio_val = encodeURIComponent(data?.question_data?.radio_val);
        }
        if (data?.question_data?.symbolic_val) {
          data.question_data.symbolic_val = encodeURIComponent(data?.question_data?.symbolic_val);
        }
        if (data?.question_data?.diastolic_val) {
          data.question_data.diastolic_val = encodeURIComponent(data?.question_data?.diastolic_val);
        }
        if (data?.question_data?.glucose_variability) {
          data.question_data.glucose_variability = encodeURIComponent(data?.question_data?.glucose_variability);
        }
        if (data?.question_data?.sensor_val) {
          data.question_data.sensor_val = encodeURIComponent(data?.question_data?.sensor_val);
        }
        if (data?.question_data?.gmi_val) {
          data.question_data.gmi_val = encodeURIComponent(data?.question_data?.gmi_val);
        }
        if (data?.question_data?.tir_val) {
          data.question_data.tir_val = encodeURIComponent(data?.question_data?.tir_val);
        }
        if (data?.question_data?.tbr_val) {
          data.question_data.tbr_val = encodeURIComponent(data?.question_data?.tbr_val);
        }
        if (data?.question_data?.tar_val) {
          data.question_data.tar_val = encodeURIComponent(data?.question_data?.tar_val);
        }
        if (data?.question_data?.cgm_comments) {
          data.question_data.cgm_comments = encodeURIComponent(data?.question_data?.cgm_comments);
        }
        if (data?.question_data?.other_comments) {
          data.question_data.other_comments = encodeURIComponent(data?.question_data?.other_comments);
        }
        if (data?.question_data?.bgm_value) {
          data.question_data.bgm_value = encodeURIComponent(data?.question_data?.bgm_value);
        }
        if (data?.question_data?.options?.length) {
          data.question_data.options.forEach((option: any) => {
            if (option.other_value) {
              option.other_value = encodeURIComponent(option.other_value);
            }
          });
        }
      }
    });
    return this.httpService.post(`admin/medscheck/save_biometrics_update`, payload);
  }

  temp_get_biometrics_update(payload: any) {
    return this.httpService.post(`admin/medscheck/adhoc/get_biometric_form`, payload);
  }
  diabetesEducationChecklist(payload: any) {
    return this.httpService.post(`admin/medscheck/adhoc/diabetes_education_checklist`, payload);
  }
  saveDiabetesEducationChecklist(payload: any) {
    return this.httpService.post(`admin/medscheck/adhoc/save_diabetes_education_checklist`, payload);
  }
  saveCaregiver(payload: any) {
    return this.httpService.post(`admin/medscheck/adhoc/adhoc_medication_report_sources_caregiver_update`, payload);
  }
  savePCprovider(payload: any) {
    return this.httpService.post(`admin/medscheck/adhoc/adhoc_medication_report_pc_provider_update`, payload);
  }

  updatePatientInfo(payload: any) {
    return this.httpService.post(`admin/medscheck/adhoc/update_patient_info`, payload);
  }

  saveDrugTherapy(payload: any) {
    return this.httpService.post(`admin/medscheck/adhoc/update_drug_therapy_problem_identified`, payload);
  }

  addTempTherapeuticIssue(payload: any) {
    return this.httpService.post(`admin/medscheck/adhoc/add_temp_therapeutic_issue`, payload);
  }

  saveMedicationChanged(payload: any) {
    return this.httpService.post(`admin/medscheck/adhoc/save_medication_changed`, payload);
  }
  medsCheckUpdate(payload: any) {
    return this.httpService.post(`admin/medscheck/adhoc/meds_check_update`, payload);
  }
  healthCareProviderServices(payload: any) {
    return this.httpService.post(`admin/medscheck/adhoc/health_care_provider_services`, payload);
  }
  saveHealthCareProviderServices(payload: any) {
    return this.httpService.post(`admin/medscheck/adhoc/save_health_care_provider_services`, payload);
  }
  getDiabetesTakeHomeSummary(payload: any) {
    return this.httpService.post(`admin/medscheck/adhoc/get_diabetes_take_home_summary`, payload);
  }
  savePatientInfoWithPharmacy(payload: any) {
    return this.httpService.post(`admin/medscheck/adhoc/save_patient_info_with_pharmacy`, payload);
  }

  saveMedicationReviewComment(payload: any) {
    return this.httpService.post(`admin/medscheck/adhoc/save_medication_review_comment`, payload);
  }

  saveKnownAllergies(payload: any) {
    return this.httpService.post(`admin/medscheck/adhoc/save_known_allergies`, payload);
  }

  getAdhocMedicationReport(payload: any) {
    return this.httpService.post(`admin/medscheck/adhoc/get_adhoc_medication_report`, payload);
  }

  adhocMedicationReportServiceUpdate(payload: any) {
    return this.httpService.post(`admin/medscheck/adhoc/adhoc_medication_report_service_update`, payload);
  }

  adhocMedicationProvider(payload: any) {
    return this.httpService.post(`admin/medscheck/adhoc/adhoc_medication_report_pc_provider_update`, payload);
  }

  adhocMedicationcaregiverUpdate(payload: any) {
    return this.httpService.post(`admin/medscheck/adhoc/adhoc_medication_report_sources_caregiver_update`, payload);
  }
  updateConsultationTopic(payload: any) {
    return this.httpService.post(`admin/medscheck/adhoc/update_consultation_topic`, payload);
  }

  patientAchieveGoals(payload: any) {
    return this.httpService.post(`admin/medscheck/led/patient_achieve_goals`, payload);
  }

  addSignatureReviewPdf(payload: FormData, options: any) {
    return this.httpFileService.post(`admin/medscheck/led/add_patient_signature`, payload, options);
  }

  getSignatureReviewPdf(payload: any) {
    return this.httpService.post(`admin/medscheck/led/get_patient_signature`, payload);
  }

  deleteSignatureReviewPdf(payload: any) {
    return this.httpService.post(`admin/medscheck/led/delete_patient_signature`, payload);
  }
  save_SC_PatientResponse(payload: any) {
    return this.httpService.post(`admin/medscheck/smoking/save-patient-response`, payload);
  }

  hear_about_the_program(payload: any) {
    return this.httpService.post(`admin/medscheck/hear_about_the_program`, payload);
  }
  getTaskManagementList(payload: any) {
    return this.httpService.post(`admin/user/tasks/index`, payload);
  }

  createTask(payload: any) {
    return this.httpService.post(`admin/user/tasks/create`, payload);
  }

  updateTask(payload: any) {
    return this.httpService.post(`admin/user/tasks/create`, payload);
  }

  updateTaskStatus(payload: any) {
    return this.httpService.post(`admin/user/tasks/change-status`, payload);
  }

}
